var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"1200px"},scopedSlots:_vm._u([(!_vm.isEdit)?{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('mf-button',{attrs:{"label":"Adicionar grupo de produtos","icon":"add"},nativeOn:{"click":function($event){return on.click($event)}}})]}}:null],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))])]),_c('v-card-text',[_c('product-group-dialog-content',{key:_vm.contentKey,ref:"productGroupDialogContent",model:{value:(_vm.localProductGroup),callback:function ($$v) {_vm.localProductGroup=$$v},expression:"localProductGroup"}})],1),_c('v-card-actions',[_c('v-spacer'),_c('mf-action-buttons',{staticClass:"pb-4 pr-4",attrs:{"primary-button":{
          text: 'Salvar',
          action: _vm.save,
          isVisible: true,
          isDisabled: false,
        },"cancel-button":{
          text: 'Cancelar',
          action: _vm.cancel,
          isVisible: true,
          isDisabled: false,
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }